var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatxzCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.565 3H8V328.174M504.565 3V328.174H8M504.565 3L521 19.4348V344.608H24.4348L8 328.174",
    stroke: "#62E160",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 328.174L24.5 344.608H521L504.565 328.174H8.5Z",
    fill: "#1F9801"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521 344.608V19.4348L504.565 3V328.174L521 344.608Z",
    fill: "#62E160"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.748 173.937L311.952 94.539C311.952 94.539 314.164 83.6624 314.846 78.2242C324.12 67.3477 338.5 80.3995 337.275 89.1007C330.757 97.8019 320.801 99.9772 320.801 99.9772C320.801 99.9772 283.19 152.184 265.491 179.376C242.261 248.985 232.306 254.423 214.606 278.351C200.226 275.089 192.483 269.65 184.739 257.686C198.014 229.842 238.943 190.252 257.748 173.937Z",
    fill: "#62E160"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 368V345H521.426V0H544.5V368H0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatxzCap);
export default __webpack_public_path__ + "static/media/boatxz-cap.bffa7c9d8fff9daa0caa08b3d62b1775.svg";
export { ForwardRef as ReactComponent };